module.exports = __webpack_public_path__ + "static/media/html.4d5d1cc9.png";